import { constraints, datatypes, inputTypes } from "data/globalData";

export const tableColumns = {
	category: {
		name: "Category",
		key: "category",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	description: {
		name: "Description",
		key: "description",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},

	value: {
		name: "Value",
		key: "value",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	supplier: {
		name: "Supplier",
		key: "supplier",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
};

export const dummySewingTrimsTableData = [
	{
		id: 1,
		category: "CMT",
		description: "CARTON BOX 51*37*45.5",
		value: 341,
		supplier: "MANOHAR FILAMENT",
	},
	{
		id: 2,
		category: "Carton tape",
		description: "CARTON TAPE 50 MTR ROLL PRICE Rs 36/- ( Consumption 3.20 mtr x 0.72 /40 pcs )",

		value: 140.76,
		supplier: "MANOHAR FILAMENT",
	},
];

export const defaultTotalRow = {
	id: "TOTAL",
	category: "Value Add",
	price: 155.0,
	value: 341,
};

export const checkForTotalColumn = (row) => {
	if (row.id === "TOTAL" || row?.[tableColumns.category.key] === "TOTAL") return true;
	return false;
};

export const calculateTotalRow = (allRows) => {
	let price = 0;
	let value = 0;
	allRows?.forEach((row) => {
		// if (!isNaN(row?.[tableColumns.value.key])) price += +row?.[tableColumns.price.key];
		if (!isNaN(row?.[tableColumns.value.key])) value += +row?.[tableColumns.value.key];
	});
	return { ...defaultTotalRow, [tableColumns.value.key]: value };
};
